import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, Collapse } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const TransactionProjectTypeListFilter = (props) => {
  const [form] = Form.useForm();

  const [projectSelect, setProjectSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    clearFilter();
  }, [props.activeTabKey]);

  const onProjectSearch = (value) => {
    if (value.length >= 2) {
      setProjectSelect({ data: [], loading: true });

      let activeProjectType =  props.activeTabKey === "1" ? "0" : props.activeTabKey === "2" ? "1" : "2";

      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name,projectType&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains(
          "projectCode",
          value
        )})  and ProjectType eq ${activeProjectType} and Name ne 'Diğer'`
      ).then((res) => {
        setProjectSelect({ data: res.value, loading: false });
      });
    } else {
      setProjectSelect({ data: [], loading: false });
    }
  };

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.id) {
        conditions.push(`id eq ${values.id}`);
      }

      if (values.projectCode) {
        conditions.push(odata.contains("projectCode", values.projectCode));
      }

  
      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query, values);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };


  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >



                <Row style={{ flexDirection: "row" }}>
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item name="id" label={ props.activeTabKey === "1" ? "Proje Adı :" : props.activeTabKey === "2" ? "Özel Hareket Adı :" : "Masraf Merkezi Adı :" }>
                      <Select
                        allowClear
                        showSearch
                        placeholder="En az 2 harf giriniz.."
                        onSearch={onProjectSearch}
                        filterOption={(input, option) =>
                          option.children
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                          option.code
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                        }
                        loading={projectSelect.loading}
                      >
                        {projectSelect.data.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                            code={item.projectCode}
                          >
                            {item.name + " (" + item.projectCode + ")"}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12} lg={6}>
                    <Form.Item name="projectCode" label={ props.activeTabKey === "1" ? "Proje Kodu :" : props.activeTabKey === "2" ? "Özel Hareket Kodu :" : "Masraf Merkezi Kodu :" }>
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default TransactionProjectTypeListFilter;
